import { IFirebaseResponse } from 'types/IFirebaseResponse'
import { createStandardAction } from 'typesafe-actions'

export const storeReaderAnswers = createStandardAction('store/readeranswers')<
  IFirebaseResponse
>()

export const downloadAnswers = createStandardAction('do/download')<void>()
